import * as types from 'constants/actionTypes';

const queryChanged = ({ query }) => (dispatch, getState) => dispatch({
    type: types.GLOSSARY_QUERY_CHANGED,
    payload: {
        query,
        originCountry: getState().profile.get('originCountry')
    },
});

module.exports = queryChanged;
